import * as React from 'react';
import IFundingChart, { TFundingChart } from './IFundingChart';
import Chart from 'react-apexcharts';
import moment from 'moment';
import { numberWithDelimiter } from '@features/utils/functions';

const purple = '#81109c';
const green = '#58b255';
const gridBorder = '#e9e9e9';

class FundingChart extends React.Component<IFundingChart, TFundingChart> {
  constructor(props: IFundingChart) {
    super(props);

    this.state = {
      options: {
        chart: { id: 'chart', toolbar: { show: false }, zoom: { enabled: false } },
        colors: [purple, green],
        stroke: { width: [0, 3], curve: 'smooth' },
        legend: { show: false },
        grid: { strokeDashArray: 5, borderColor: gridBorder },
        plotOptions: { bar: { columnWidth: this.props.funding.length < 5 ? '10%' : '30%' } },
        responsive: [{
          breakpoint: 420,
          options: { chart: { height: '300px' }, xaxis: { labels: { show: false } } },
        }],
        markers: {
          size: 5,
          strokeColors: green,
        },
        xaxis: {
          type: 'category',
          labels: {
            formatter: this.dateFormat,
          },
          categories: this.getDates(),
        },
        yaxis: [{
          title: {
            text: 'Raised funding (USD)',
            style: { color: purple },
          },
          labels: { style: { colors: purple }, formatter: this.formatAmount },
        }, {
          opposite: true,
          title: {
            text: 'Share Price (USD)',
            style: { color: green },
          },
          labels: { style: { colors: green }, formatter: this.formatAmount },
        }],
      },
      series: [{
        name: 'Raised funding (USD)',
        type: 'column',
        data: this.getBarData(),
      }, {
        name: 'Share Price (USD)',
        type: 'line',
        data: this.getLineData(),
      }],
    };
  }

  dateFormat = (value: string, timestamp: number, index: number) => {
    return moment(new Date(value)).format('MMM \'YY');
  }

  formatAmount = (value: number) => {
    const formatter: Intl.NumberFormat = new Intl.NumberFormat('sfb', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    });
  
    return formatter.format(value);
  }

  getLineData = () => [...this.props.funding, { share_price: 0 }].reverse().map(el => Number(el.share_price) || 0);

  getBarData = () => [...this.props.funding, { money_raised: 0 }].reverse().map(el => Number(el.money_raised) || 0);

  getDates = () => [...this.props.funding, { date: String(this.props.founded) }].reverse().map(el => el.date);

  render() {
    return (
      <Chart
        options={this.state.options}
        series={this.state.series}
        type="line"
        width="100%"
        height="400px"
      />
    );
  }
}

export default FundingChart;
